// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__36RRR","title":"BackImages_title__32vEK","images":"BackImages_images__3vttU"};